<template>
	<a-spin :spinning="$store.state.singleVueLoading">
		<a-layout class="layout-admin">
			<layout-header @sendmsg="getmsg" />
			<a-layout style="width: 1200px;margin: 20px auto;">
				<layout-sider v-if="abs"></layout-sider>
				<a-layout class="layout-main">
					<a-layout-content class="layout-content">
						<!-- <tabs-view/> -->
						<router-view />
					</a-layout-content>
				</a-layout>
			</a-layout>
			<LayoutFooter />
		</a-layout>
	</a-spin>
</template>

<script>
import LayoutHeader from "@/layout/layoutPage/header/LayoutHeaderNew2";
import LayoutSider from "@/layout/layoutPage/aside/LayoutSider";
// import LayoutBackFooter from "@/layout/layoutPage/backfooter/LayoutBackFooter";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2'
// import TabsView from '@/components/other/TabsView.vue';
import { scrollNotice } from "@/api/adminService";

export default {
	name: "index",
	components: {
		LayoutHeader,
		LayoutSider,
		LayoutFooter
		// LayoutBackFooter,
		// TabsView,
	},
	data() {
		return {
			abs: true,
			noticeData: []
		}
	},
	mounted() {
		this.getNoticeData()
	},
	methods: {
		getmsg(val) {
			this.abs = val
		},
		getNoticeData() {
			this.getAction({
				url: scrollNotice.pageList,
			}).then(res => {
				this.noticeData = res.records
				console.log(res,53);
			})
		},
		goPolicyNoticeDetail(item) {
			if (item.noticeType == '3' && this.$ls.get("roleCode").includes('company')) {
				if (item.title.indexOf('积分制') > 0) {
					this.$router.push({ path: '/sys/manage' })
				} else if (item.title.indexOf('政策兑现') > 0) {
					this.$router.push({ path: '/sys/policyPublicData' })
				}
			} else {
				this.$router.push({
					path: "/noticeDetail",
					query: { id: item.id, source: 'piao' }
				})
			}
		},
	},
}
</script>

<style scoped lang="less">
.noticeBox {
	width: 100%;
	background-color: #fff;
	// margin-top: 20px;

	.notice {
		width: 1200px;
		padding: 10px 0;
		margin: 0 auto;

		.box {
			display: flex;
			justify-content: space-around;
		}
	}
}

:deep(.ant-divider-vertical) {
	top: 0.05em;
	height: 1.8em;
}

.layout-admin {
	// height: 100vh;
	// overflow: hidden;
	min-width: 1200px;
	min-height: 100vh;
}

.layout-content {
	// overflow-y: auto;
	padding: 10px;
}
</style>
